import { Provider } from 'react-redux';
import { Outlet } from 'react-router-dom';

import contextSystemStore from './store/contextSystemStore';

export default function ContextSystemLayout() {
  return (
    <Provider store={contextSystemStore}>
      <Outlet />
    </Provider>
  );
}
